import GenericInformationTable, {
    TableRow
} from "components/ui/table/GenericInformationTable";
import { getCareLevelDisplayName } from "types/careLevel";

interface Props {
    firstName: string | null;
    lastName: string | null;
    clientTitle: string | null;
    email: string | null;
    productName: string;
    requestZipCode: string | null;
    requestRegion: string | null;
    source: string | null;
    age: string | null;
    careLevel: string | null;
    comments: string | null;
    phoneNumber: string | null;
}

/**
 * ImportLeadBasicInformationTable displays key lead information using the GenericInformationTable.
 * It builds an array of table rows for fields such as the client's name, phone number, product need, and more.
 */
function ImportLeadBasicInformationTable({
    firstName,
    lastName,
    clientTitle,
    email,
    productName,
    requestZipCode,
    requestRegion,
    source,
    age,
    careLevel,
    comments,
    phoneNumber
}: Readonly<Props>) {
    // Return the client name (or a placeholder when not allowed).
    function getClientName(
        clientTitle: string | null,
        firstName: string | null,
        lastName: string | null
    ): string {
        if (
            clientTitle &&
            !["Unbekannt", "Keine Angabe"].includes(clientTitle) &&
            firstName &&
            lastName
        ) {
            return `${clientTitle} ${firstName} ${lastName}`;
        }
        if (firstName && lastName) {
            return `${firstName} ${lastName}`;
        }
        if (firstName) {
            return firstName;
        }
        if (lastName) {
            return lastName;
        }
        return "--";
    }

    function showValueIfNotNull(value: string | null): string {
        return value ? value : "--";
    }

    function showRegionZip(
        requestRegion: string | null,
        requestZipCode: string | null
    ): string {
        if (!requestRegion && !requestZipCode) {
            return "--";
        }
        if (requestRegion && requestZipCode) {
            return `${requestRegion}, ${requestZipCode}`;
        }
        return requestRegion || requestZipCode || "--";
    }

    const rows: TableRow[] = [
        {
            fieldName: "Name:",
            value: getClientName(clientTitle, firstName, lastName)
        },
        {
            fieldName: "E-Mail-Adresse:",
            value: showValueIfNotNull(email)
        },
        {
            fieldName: "Telefonnummer:",
            value: showValueIfNotNull(phoneNumber)
        },
        {
            fieldName: "Bedarf:",
            value: productName
        },
        {
            fieldName: "Bedarfsort:",
            value: showRegionZip(requestRegion, requestZipCode)
        },
        {
            fieldName: "Alter:",
            value: showValueIfNotNull(age)
        },
        {
            fieldName: "Pflegegrad:",
            value: careLevel
                ? getCareLevelDisplayName(careLevel)
                : showValueIfNotNull(null)
        },
        {
            fieldName: "Quelle:",
            value: showValueIfNotNull(source)
        },
        {
            fieldName: "Interner Kommentar:",
            value: showValueIfNotNull(comments),
            isExpandable: true
        },
        {
            fieldName: "Zuständiger Mitarbeiter:",
            value: "Hans Müller",
            isDataShowable: true
        }
    ];

    return (
        <div>
            <h3 className="text-blue">Rufen Sie jetzt an:</h3>
            <GenericInformationTable
                title="Die wichtigsten Daten auf einen Blick"
                rows={rows}
            />
        </div>
    );
}

export default ImportLeadBasicInformationTable;
